import {
    DataListCell,
    DataListCellValue,
    DataListColumn,
    RowData,
    RowWithNormalizedData,
} from './types';
import { List } from './List';
import { Row } from './Row';

export class Cell {
    data: DataListCell;
    id: string;
    name: string;
    config: DataListColumn;
    value: DataListCellValue;
    row: Row;

    constructor(cell: DataListCell, config: DataListColumn, row: Row) {
        this.data = cell;

        this.id = cell.id;

        this.name = config.name;

        this.config = config;

        this.value = cell.value;

        this.row = row;

        if (cell.is_raw_json === 'true') {
            this.value = typeof this.value === 'string' ? JSON.parse(this.value) : this.value;
        }
    }

    /**
     * Check if cell is of a given type
     */
    isType(type: string): boolean {
        return this.config.type.toUpperCase() === type.toUpperCase();
    }

    /**
     * Check if cell is of type LIST
     */
    isList(): boolean {
        return this.isType('LIST');
    }

    /**
     * Check if cell is a list cell with data
     */
    isListWithData(): boolean {
        return this.isList() &&
            this.value &&
            typeof this.value !== 'string' &&
            this.value instanceof List &&
            (this.value.ID || this.value.rows)
            ? true
            : false;
    }

    /**
     * Get the row of which this cell is a member
     */
    getRow(): Row {
        return this.row;
    }

    /**
     * Serialize cell for signs list widget
     */
    serializeForSigns(
        withNormalized: boolean
    ): Array<RowData | RowWithNormalizedData | Record<string, unknown>> | Record<string, unknown> {
        if (this.isList()) {
            if (this.value && this.value instanceof List) {
                return this.value.serializeForSigns(withNormalized);
            }

            return [];
        }

        return {
            id: this.id,
            is_raw_json: this.data.is_raw_json,
            row_id: this.row.id,
            column_ordinal: this.config.ordinal,
            row_ordinal: this.row.ordinal,
            value: this.value,
        };
    }
}
